const _excluded = ["selected", "CUSTOM_BRANDING", "onClick"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Typography, Button } from 'seagull';
import { Checkmark } from 'seagull/icons';
import { Intent } from "../../../infra/access-control";
import styles from "./BottomArea.module.scss";
export default function BottomArea(_ref) {
  let {
      selected,
      CUSTOM_BRANDING,
      onClick
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.bottomArea
  }, selected ? /*#__PURE__*/React.createElement(Typography, {
    className: styles.selectedIndicator,
    "data-testid": "".concat(props['data-testid'], "-selected")
  }, CUSTOM_BRANDING ? '' : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkmark, null), ' '), "Selected") : /*#__PURE__*/React.createElement(Button, {
    intent: Intent.SelectPackage,
    "data-testid": "".concat(props['data-testid'], "-select-btn"),
    skin: "primaryOutlineOpaque",
    onClick: onClick
  }, "Select"));
}